export type TimeRemaining = {
  days: number
  hours: number
  minutes: number
  seconds: number
  total: number
}

export default function getTimeRemaining(now: Date, date: Date): TimeRemaining {
  const total = Math.max(0, date.getTime() - now.getTime())
  const seconds = Math.floor((total / 1000) % 60)
  const minutes = Math.floor((total / 1000 / 60) % 60)
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24)
  const days = Math.floor(total / (1000 * 60 * 60 * 24))

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  }
}
